/* eslint-disable import/no-anonymous-default-export */
import { API } from "src/domains/shared/utils/amplifyCompat";
import { DRONESQUARE_API_GATEWAY } from "src/domains/shared/constants/constants";
import {
  createUserOfProjectProps,
  deleteUserOfProjectProps,
  getUsersOfProjectProps,
  patchUsersOfProjectProps,
} from "./usersOfProject.queries";
import { UserOfProject } from "./usersOfProject.modal";
import { unwrapEnvelopeList } from "src/domains/shared/utils/unwrapEnvelope";

class ProjectUserRepository {
  /** 멤버 목록 조회 — 봉투 실패는 경계에서 오류로 승격한다(빈 목록으로 접지 않는다). */
  async getUsersOfProject({
    projectId,
  }: getUsersOfProjectProps): Promise<UserOfProject[]> {
    const res = await API.get(
      DRONESQUARE_API_GATEWAY,
      `projects/${projectId}/users`,
      {}
    );
    return unwrapEnvelopeList<UserOfProject>(res);
  }

  async createUserOfProject({ projectId, email }: createUserOfProjectProps) {
    return API.post(DRONESQUARE_API_GATEWAY, `projects/${projectId}/users`, {
      body: { email },
    });
  }

  async patchUsersOfProject({
    projectId,
    patchData,
  }: patchUsersOfProjectProps) {
    return API.patch(DRONESQUARE_API_GATEWAY, `projects/${projectId}/users`, {
      body: [...patchData],
    });
  }

  async deleteUserOfProject({
    projectId,
    email,
    status,
  }: deleteUserOfProjectProps) {
    return API.del(DRONESQUARE_API_GATEWAY, `projects/${projectId}/users`, {
      body: { email, status },
    });
  }
}

export default new ProjectUserRepository();
